import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BugService } from 'src/app/private/services/bug.service';
import { ProjectService } from 'src/app/private/services/project.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { EpicService } from 'src/app/private/services/epic.service';
import { ProjectFeatureService } from 'src/app/private/services/project-feature.service';
import { UserStoryService } from 'src/app/private/services/user-story.service';

@Component({
  selector: 'app-bug-form',
  templateUrl: './bug-form.component.html',
  styleUrls: ['./bug-form.component.scss']
})
export class BugFormComponent implements OnInit {

  @Input() editData: any = {};
  @Input() projectId!: number;
  @Input() accountId!: number;
  @Input() btnLoading!:  boolean;
  submitted = false;
  @Output() formSubmit = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() success = new EventEmitter(); // New output for success
  oldBugData: any = {};
  @Input() formAction: any = '';
  public Editor = ClassicEditor as unknown as any;
  
  editorConfig: any = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'fontSize',
        'fontColor',
        'fontBackgroundColor',
        '|',
        'alignment',
        '|',
        'numberedList',
        'bulletedList',
        '|',
        'outdent',
        'indent',
        '|',
        'link',
        'blockQuote',
        'insertTable',
        '|',
        'undo',
        'redo'
      ],
      shouldNotGroupWhenFull: true
    },
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
      ]
    },
    fontSize: {
      options: [
        'tiny',
        'small',
        'default',
        'big',
        'huge'
      ]
    },
    fontColor: {
      colors: [
        { color: '#000000', label: 'Black' },
        { color: '#4D4D4D', label: 'Dark Grey' },
        { color: '#999999', label: 'Grey' },
        { color: '#FFFFFF', label: 'White', hasBorder: true },
        { color: '#E74C3C', label: 'Red' },
        { color: '#E67E22', label: 'Orange' },
        { color: '#F39C12', label: 'Yellow' },
        { color: '#27AE60', label: 'Green' },
        { color: '#3498DB', label: 'Blue' },
        { color: '#9B59B6', label: 'Purple' }
      ]
    },
    fontBackgroundColor: {
      colors: [
        { color: '#FFFFFF', label: 'White', hasBorder: true },
        { color: '#FFEBEE', label: 'Light Red' },
        { color: '#FFF3E0', label: 'Light Orange' },
        { color: '#FFF9C4', label: 'Light Yellow' },
        { color: '#E8F5E9', label: 'Light Green' },
        { color: '#E3F2FD', label: 'Light Blue' },
        { color: '#F3E5F5', label: 'Light Purple' }
      ]
    },
    alignment: {
      options: ['left', 'center', 'right', 'justify']
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    link: {
      decorators: {
        openInNewTab: {
          mode: 'manual',
          label: 'Open in a new tab',
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        }
      }
    },
    placeholder: 'Enter description here...',
    // Custom enter mode behavior (handled in onReady)
    enterMode: 'SHIFT+ENTER'
  };
  bugForm!: FormGroup;
  users: any[] = [];
  modulesList :any [] = []
  attachments: any[] = [];

  // ── Project Hierarchy State ────────────────────────────────────────────────
  epics: any[] = [];
  formFeatures: any[] = [];
  formUserStories: any[] = [];

  selectedFormEpicId: any = null;
  selectedFormFeatureId: any = null;

  constructor(
    private fb: FormBuilder,
    private projectService: ProjectService,
    private bugAPI: BugService,
    private localStorage: LocalStorageService,
    private epicService: EpicService,
    private featureService: ProjectFeatureService,
    private userStoryService: UserStoryService
  ) { }
onReady(editor: any) {
    // Set custom upload adapter (optional, as you have)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      return new UploadAdapter(loader);
    };

    // Custom behavior: replace default Enter with Shift+Enter
    editor.editing.view.document.on(
      'enter',
      (evt: any, data: any) => {
        editor.execute('shiftEnter'); // insert <br> instead of <p>
        data.preventDefault();        // cancel default enter
        evt.stop();                   // stop further handling
      },
      { priority: 'high' }
    );
  }

  isImage(item: any): boolean {
  if (!item) return false;

  const imageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif'];

  // Prefer MIME type
  if (item.type) {
    return imageTypes.includes(item.type);
  }

  // Fallback to extension check
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(item.url);
}

onImgError(event: Event) {
  const img = event.target as HTMLImageElement;
  img.src = 'assets/img/file-placeholder.png';
}
  closeForm() {
    this.close.emit();
  }
  ngOnInit(): void {
    this.createForm();
    this.loadUsers();
    this.loadProjectModules();
    this.loadEpics();

    if (this.editData && Object.keys(this.editData).length > 0) {
      console.log("Editing bug data:", this.editData);
      console.log("Editing bug data:", this.oldBugData);
      this.oldBugData = JSON.parse(JSON.stringify(this.editData));  // deep clone
      this.bugForm.patchValue(this.editData);
      
      if (this.editData?.user_story) {
        this.selectedFormEpicId = this.editData.user_story.feature?.epic?.epic_id || null;
        this.selectedFormFeatureId = this.editData.user_story.feature?.feature_id || null;
        this.bugForm.patchValue({ user_story_id: this.editData.user_story.user_story_id });

        if (this.selectedFormEpicId) {
          this.loadFormFeatures(this.selectedFormEpicId, () => {
            if (this.selectedFormFeatureId) {
              this.loadFormUserStories(this.selectedFormFeatureId);
            }
          });
        }
      } else {
        this.selectedFormEpicId = null;
        this.selectedFormFeatureId = null;
        this.bugForm.patchValue({ user_story_id: null });
        this.formFeatures = [];
        this.formUserStories = [];
      }

      // Clear the internal_comments field so user must add new comment
      this.bugForm.patchValue({
        internal_comments: ''
      });
    }
  }

  // Method to clear comment after successful submission
  clearCommentField() {
    this.bugForm.patchValue({
      internal_comments: ''
    });
    this.bugForm.get('internal_comments')?.markAsUntouched();
  }

  get form() {
    return this.bugForm.controls;
  }
  onUploadComplete(event: any) {
  const currentAttachments = this.bugForm.get('attachments')?.value || [];

  // Normalize event to array
  const newAttachments = Array.isArray(event) ? event : [event];

  // Merge existing + new
  const updatedAttachments = [...currentAttachments, ...newAttachments];

  this.bugForm.patchValue({
    attachments: updatedAttachments
  });

  console.log('Upload complete:', updatedAttachments);
}

removeAttachment(index: number) {
  const attachments = this.bugForm.get('attachments')?.value || [];

  if (index < 0 || index >= attachments.length) return;

  attachments.splice(index, 1);

  this.bugForm.patchValue({
    attachments
  });
}
  showPreview = false;
selectedIndex = 0;

openPreview(i: number) {
  this.selectedIndex = i;
  this.showPreview = true;
}
  createForm() {
    this.bugForm = this.fb.group({
      project_id: [this.projectId, Validators.required],
      client_id: [this.localStorage.getClientId(), Validators.required],
      account_id: [this.accountId],
      created_by: this.formAction === 'Add' ? this.localStorage.getUserId() : null,
      updated_by: this.formAction === 'Update' ? this.localStorage.getUserId() : null,
      title: ['', Validators.required],
      description: [''],
      steps_to_reproduce: [''],

      type: ['', Validators.required],
      severity: ['', Validators.required],
      priority: ['', Validators.required],
      status: ['', Validators.required],
      environment: ['', Validators.required],

      device_info: [''],
      os_info: [''],
      browser_info: [''],
      app_version: [''],
      module_id:[null],
      assigned_to: [null],
      tester_id: [null],
      reported_by:[null],
      due_date: [null],
      internal_comments: ['',Validators.required],
      attachments: [[]],
      user_story_id: [null]
    });
  }

  loadUsers() {
    const param = {
      client_id: this.localStorage.getClientId(),
      project_id: this.projectId,
      user_id: this.localStorage.getUserId(),
    };

    this.projectService.getProjectMembers(param).subscribe({
      next: (res: any) => {
        this.users = this.projectService.parseProjectMembersResponse(res);
      },
      error: (err) => console.error(err)
    });
  }
  loadProjectModules(){
      const param = {
      project_id: this.projectId
    };

    this.bugAPI.getProjectModuleList(param).subscribe({
      next: (res: any) => this.modulesList = res,
      error: (err) => console.error(err)
    });
  }

  handleFileUpload(event: any) {
    const files = event.target.files;
    let uploaded = [];

    for (let file of files) {
      uploaded.push({
        file_name: file.name,
        size: file.size,
        type: file.type
      });
    }

    this.bugForm.patchValue({
      attachments: uploaded
    });
  }

  // -----------------------------------------------------------
  // ⭐ BUILD ACTIVITY LOG (OLD VALUE • NEW VALUE • ACTION)
  // -----------------------------------------------------------
  buildActivityLogs(): any[] {
    const logs: any[] = [];

    const formValue = this.bugForm.value;

    const fieldsToTrack = [
      'title',
      'description',
      'steps_to_reproduce',
      'priority',
      'severity',
      'status',
      'type',
      'assigned_to',
      'due_date',
      'attachments',
      'internal_comments',
      'user_story_id'
    ];

    fieldsToTrack.forEach(field => {
      const oldVal = this.oldBugData[field];
      const newVal = formValue[field];

      console.log(`Comparing field: ${field}, old: ${oldVal}, new: ${newVal}`);

      if (String(oldVal) !== String(newVal)) {
        
        // let actionType = "update";
        // let description = `${field} changed from ${oldVal} → ${newVal}`;
        let actionType = '';
        let description = '';

        if (field === 'status') {
          const oldVal_ = this.prettyAction(oldVal);
          const newVal_ = this.prettyAction(newVal);
          actionType = 'status_change';
          description = `Status changed from <strong> ${oldVal_} </strong> → <strong>${newVal_}</strong>`;
        }
        if (field === 'severity') {
          actionType = 'severity_change';
          description = `Severity changed from <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }
        if (field === 'priority') {
          actionType = 'priority_change';
          description = `Priority changed from <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }
        if (field === 'type') {
          actionType = 'type_change';
          description = `Type changed from <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }
        if (field === 'assigned_to') {
          actionType = 'assignment';
          description = `Assigned to user <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }
        if (field === 'due_date') {
          actionType = 'due_date_change';
          description = `Due date changed from <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }
        if (field === 'internal_comments') {
          actionType = 'internal_comments_change';
          description = `Comment changed from <strong>${oldVal} </strong> → <strong>${newVal}</strong>`;
        }

        logs.push({
          action_type: actionType,
          old_value: { [field]: oldVal },
          new_value: { [field]: newVal },
          description,
          user_id: this.localStorage.getUserId()
        });
      }
    });

    return logs;
  }
prettyAction(type: string) {
  return type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
scrollToFirstError() {
  // First, try to find the first visible error message
  const firstErrorMessage: any = document.querySelector('.errors');
  
  if (firstErrorMessage) {
    firstErrorMessage.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    
    // Try to focus the associated input field
    const parentElement = firstErrorMessage.closest('.mb-3');
    if (parentElement) {
      const inputElement: any = parentElement.querySelector('input, select, textarea');
      if (inputElement) {
        setTimeout(() => inputElement.focus(), 300);
      }
    }
    return;
  }

  // Fallback: Find first invalid form control
  const firstInvalidControl = document.querySelector('.form-control.ng-invalid');
  if (firstInvalidControl) {
    firstInvalidControl.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    setTimeout(() => (firstInvalidControl as HTMLElement).focus(), 300);
  }
}
  //------------------------------------------------------------
  // ⭐ SUBMIT FORM (CREATE / UPDATE + ACTIVITY)
  //------------------------------------------------------------
  submitForm() {
    this.submitted = true;


    if (this.bugForm.invalid) {
       this.scrollToFirstError();
      this.bugForm.markAllAsTouched();
      return;
    }

    let payload: any = {
      ...this.bugForm.value
    };

    // ADD bug_id when updating
    if (this.oldBugData && this.oldBugData.bug_id) {
      payload.bug_id = this.oldBugData.bug_id;
    }

    // CREATE MODE activity
    if (this.formAction === 'Add') {
      payload.created_by = this.localStorage.getUserId()
      payload.activity_log = [
        {
          action_type: "create",
          description: "Bug created",
          user_id: this.localStorage.getUserId()
        }
      ];
    } 
    else {
      // UPDATE MODE → multiple Jira-style logs
      const logs = this.buildActivityLogs();
      payload.updated_by = this.localStorage.getUserId()
      if (logs.length > 0) {
        payload.activity_log = logs;
      }
    }
    console.log("Form submitted with payload:", payload);
    this.formSubmit.emit(payload);
  }

  // ── Form Hierarchy Cascading Helpers ───────────────────────────────────────
  loadEpics() {
    this.epicService.getAllEpics({
      client_id: this.localStorage.getClientId(),
      project_id: this.projectId,
      limit: 1000
    }).subscribe({
      next: (res: any) => {
        this.epics = res?.rows || res?.data?.rows || res?.data || [];
      }
    });
  }

  onFormEpicChange(epicId: any) {
    this.selectedFormEpicId = epicId ? Number(epicId) : null;
    this.selectedFormFeatureId = null;
    this.bugForm.patchValue({ user_story_id: null });
    this.formFeatures = [];
    this.formUserStories = [];

    if (this.selectedFormEpicId) {
      this.loadFormFeatures(this.selectedFormEpicId);
    }
  }

  loadFormFeatures(epicId: number, callback?: () => void) {
    this.featureService.getAllFeatures({
      client_id: this.localStorage.getClientId(),
      epic_id: epicId,
      limit: 1000
    }).subscribe({
      next: (res: any) => {
        this.formFeatures = res?.rows || res?.data?.rows || res?.data || [];
        if (callback) callback();
      }
    });
  }

  onFormFeatureChange(featureId: any) {
    this.selectedFormFeatureId = featureId ? Number(featureId) : null;
    this.bugForm.patchValue({ user_story_id: null });
    this.formUserStories = [];

    if (this.selectedFormFeatureId) {
      this.loadFormUserStories(this.selectedFormFeatureId);
    }
  }

  loadFormUserStories(featureId: number) {
    this.userStoryService.getAllUserStories({
      client_id: this.localStorage.getClientId(),
      feature_id: featureId,
      limit: 1000
    }).subscribe({
      next: (res: any) => {
        this.formUserStories = res?.rows || res?.data?.rows || res?.data || [];
      }
    });
  }
}


export class UploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  public async upload(): Promise<any> {
    return this.loader.file
      .then((file: File) => this.readThis(file))
      .then((dataUrl: any) => {
        return { default: dataUrl };
      });
  }

  readThis(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
}